// extracted by mini-css-extract-plugin
module.exports = {"main":"styles__main___3y_HA","items":"styles__items___3LsGr"};